import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const MainChartSidebarContainer = styled.div`
  position: relative;
`;

export const MainChartSidebarHeadingContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    align-items: baseline;
  }
`;

export const MainChartSidebarFormContainer = styled.div`
  margin-top: 24px;
`;
